import { v4 as uuidv4 } from "uuid";

export const getUserHeaders = () => {
    return {
        "x-request-id": uuidv4(),
    };
};

export const isBrowserEnv = () => typeof window !== "undefined";
